/* A schedule's roll-ups (Duncan 2026-10-29, the PM meeting; his picks): a section's and the whole job's % complete are their
   tasks' %, each weighted by its working days -- as Microsoft Project rolls a summary up -- and their dates the earliest
   start to the latest finish. A milestone weighs nothing (a point in time, as in Project). The Schedule's job header, its
   section lines and the Gantt's section bars all read these, so they always agree. */

/** Working days from start to finish, both counted: Mon-Fri, or every day on a 7-day week. 0 without dates. */
export function workingDays(start, finish, workWeek = '5') {
  const s = new Date(`${String(start || '').slice(0, 10)}T00:00:00`);
  const f = new Date(`${String(finish || start || '').slice(0, 10)}T00:00:00`);
  if (Number.isNaN(s.getTime()) || Number.isNaN(f.getTime()) || f < s) return 0;
  if (String(workWeek) === '7') return Math.round((f - s) / 86400000) + 1;
  let n = 0;
  for (const d = new Date(s); d <= f; d.setDate(d.getDate() + 1)) {
    const w = d.getDay();
    if (w !== 0 && w !== 6) n += 1;
  }
  return n;
}

const pctOf = (t) => Math.max(0, Math.min(100, Number(t.percent_complete ?? t.progress) || 0));
const isMilestone = (t) => !!Number(t.milestone_flag ?? t.is_milestone);
const finishOf = (t) => t.finish_date || t.end_date || t.start_date;

/** These tasks rolled up: { pct (whole number, or null when no task has working days), start, finish }. Bottom rows only
    (subtasks, 2026-11-01): a parent sums its subtasks up, so it's skipped -- counted on top of them it would count its
    work twice -- and so is the list's "+ Add a subtask" row. */
export function rollUp(tasks, workWeek = '5') {
  let weight = 0;
  let done = 0;
  let start = null;
  let finish = null;
  const list = (tasks || []).filter((t) => !t._addFor);
  const parents = new Set(list.map((t) => t.parent_task_id ?? t.parent_id).filter((id) => id != null).map(Number));
  list.forEach((t) => {
    if (t.start_date && (!start || t.start_date < start)) start = t.start_date;
    const f = finishOf(t);
    if (f && (!finish || f > finish)) finish = f;
    if (isMilestone(t) || t._kids || parents.has(Number(t.id))) return;
    const d = workingDays(t.start_date, finishOf(t), workWeek) || 1;
    weight += d;
    done += d * pctOf(t);
  });
  return { pct: weight ? Math.round(done / weight) : null, start, finish };
}
